import { Navigate } from "react-router-dom";
import KeycloakService from "../services/KeycloakService";

export function RoleProtectedRoute({ children, groups }: { children: JSX.Element, groups: string[] }) {

    return KeycloakService.hasGroup(groups) ? children : <Navigate to='/'/>
}